const cmpHomepageHero = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element

    // let autoplay = _.component.getAttribute('data-autoplay')
    // autoplay = isNaN(autoplay) || autoplay === '0' ? false : autoplay * 1000

    // let loop = _.component.getAttribute('data-loop')
    // loop = loop === 'true' ? true : false

    //const slides = _.component.querySelectorAll('.cmp-homepage-hero__slide')
    const bootstrapSlides = _.component.querySelectorAll('.carousel-item.bg-light')
    const bulletIndicator = _.component.querySelectorAll('.cmp-homepage-hero.carousel .glide__bullets .glide__bullet')
    // if (slides.length > 1) {
    //   _.showSlides(slides)
    //   _.showBullets(_.component, slides, autoplay, loop)
    // } else if (slides.length === 1) {
    //   _.showSlides(slides)
    // } else {
    //   return false
    // }

    if (bootstrapSlides.length > 0)
      _.showBootStrapSlides(bootstrapSlides, bulletIndicator)
  },
  // showBullets: function (component, slides, autoplay, loop) {
  //   const bulletsContainer = component.querySelector('.glide__bullets')
  //   bulletsContainer.innerHTML = ''

  //   for (let index = 0; index < slides.length; index++) {
  //     const button = document.createElement('button')
  //     button.classList.add('glide__bullet')
  //     button.setAttribute('data-slide-pos', index)
  //     bulletsContainer.appendChild(button)
  //   }

  //   const bullets = component.querySelectorAll('.glide__bullets button')
  //   // set first bullet as active
  //   bullets[0].classList.add('glide__bullet--active')

  //   let intervalId = null
  //   if (autoplay) {
  //     intervalId = setInterval(function () {
  //       autoplayCarousel(slides, component, loop)
  //     }, autoplay)
  //   }

  //   bullets.forEach((bullet) => {
  //     bullet.addEventListener('click', function (e) {
  //       const position = bullet.getAttribute('data-slide-pos')

  //       bullets.forEach((bullet) => {
  //         bullet.classList.remove('glide__bullet--active')
  //       })
  //       bullet.classList.add('glide__bullet--active')
  //       moveSlideTo(position, slides, component)

  //       // When click if autoplay is enabled, reset interval
  //       if (autoplay) {
  //         clearInterval(intervalId)
  //         intervalId = setInterval(function () {
  //           autoplayCarousel(slides, component, loop)
  //         }, autoplay)
  //       }
  //     })
  //   })

  //   function autoplayCarousel(slides, component, loop) {
  //     let position = 0
  //     const slidesAmount = slides.length - 1
  //     slides.forEach((slide, index) => {
  //       if (slide.classList.contains('active')) {
  //         position = index
  //         position++
  //       }
  //     })

  //     if (position <= slidesAmount) {
  //       moveSlideTo(position, slides, component)
  //     } else if (position > slidesAmount && loop) {
  //       moveSlideTo(0, slides, component)
  //     }
  //   }
  // },
  // showSlides: function (slides) {
  //   const activeSlide = slides[0]
  //   activeSlide.classList.add('active')
  //   const content = activeSlide.querySelector(
  //     '.cmp-homepage-hero__content__box'
  //   )
  //   content.classList.add('active')

  //   // animate content
  //   content.querySelector('.animate-content').classList.add('active')
  // },

  showBootStrapSlides: function (bootstrapSlides, bulletIndicator) {
    const activeBootStrapSlide = bootstrapSlides[0]
    activeBootStrapSlide.classList.add('active')
    const contentBootStrapItem = activeBootStrapSlide.querySelector('.cmp-homepage-hero__content__box')
    contentBootStrapItem.classList.add('active')
    // animate content
    contentBootStrapItem.querySelector('.animate-content').classList.add('active')
    //activate bullet
    const activeBullet = bulletIndicator[0]
    activeBullet.classList.add('active')

    this.component.addEventListener('slid.bs.carousel', function (event) {
      const oldSlideContent = document.querySelector('.cmp-homepage-hero__content__box.active')
      oldSlideContent.classList.remove('active')
      oldSlideContent.querySelector('.animate-content').classList.remove('active')

      const activeBootStrapSlideItem = document.querySelector('.cmp-homepage-hero__slide.carousel-item.active')
      const contentBootStrapItemBox = activeBootStrapSlideItem.querySelector('.cmp-homepage-hero__content__box')
      contentBootStrapItemBox.classList.add('active')
      // animate content
      contentBootStrapItemBox.querySelector('.animate-content').classList.add('active')
    })
  }
}
// function moveSlideTo(position, slides, component) {
//   // remove all active states from slides
//   slides.forEach((slide) => {
//     slide.classList.remove('active')
//     const content = slide.querySelector('.cmp-homepage-hero__content__box')
//     content.classList.remove('active')
//     // remove active state on content animation
//     content.querySelector('.animate-content').classList.remove('active')
//   })
//   const activeSlide = slides[position]
//   // show slide
//   activeSlide.classList.add('active')

//   // show content
//   const content = activeSlide.querySelector('.cmp-homepage-hero__content__box')
//   content.classList.add('active')

//   // animate content
//   content.querySelector('.animate-content').classList.add('active')

//   // remove all active bullets
//   const bullets = component.querySelectorAll('.glide__bullets button')
//   bullets.forEach((bullet) => {
//     bullet.classList.remove('glide__bullet--active')
//   })
//   // mark active bullet
//   bullets[position].classList.add('glide__bullet--active')
// }

export default cmpHomepageHero
